export default [
    {
        "name": "Happy Buy Buy",
        "shipRoute": "Sea Standard",
        "shipEndDate": "2023-01-21T19:00:00",
        "pickupLocation": {
            "name": "Jasmine",
            "address": "101 East Santa Clara Street, San Jose, CA, USA",
            "notes": "",
            "geoLatitude": 37.3374561,
            "geoLongitude": -121.8884615,
            "shortAddress": "San Jose, CA"
        },
        "user": "test@test.com",
        "phaseNumber": 3,
        "trackingNumber": "5570 8000 0135 9688",
        "courier": "dhl",
        "members": [
            "test@test.com"
        ],
        "phoneNumber": "6508809999",
        "created": "2023-03-15T04:02:52.337000",
        "modified": "2023-04-02T23:46:45.416000",
        "totalWeight": 13.0,
        "id": "6411436c04c6777b3e65ca93"
    },
    {
        "name": "Crazy Shoppers",
        "shipRoute": "Air Sensitive",
        "shipEndDate": "2023-03-30T19:00:00",
        "pickupLocation": {
            "name": "Jasmine",
            "address": "2051 Stierlin Court, Sunnyvale, CA, USA",
            "notes": "",
            "geoLatitude": 37.4239737,
            "geoLongitude": -122.0705172,
            "shortAddress": "Sunnyvale, CA"
        },
        "user": "test@test.com",
        "phaseNumber": 2,
        "trackingNumber": "3342476771",
        "courier": "dhl",
        "members": [
            "test@test.com"
        ],
        "phoneNumber": "6509907654",
        "created": "2023-03-15T04:05:10.006000",
        "modified": "2023-04-04T19:32:14.047000",
        "totalWeight": 2.8,
        "id": "641143f6bd7c774187a11f06"
    },
    {
        "name": "Santa Clara Group",
        "shipRoute": "Sea Standard",
        "shipEndDate": "2023-05-03T19:00:00",
        "pickupLocation": {
            "name": "Jasmine",
            "address": "Santa Clara Marriott, Mission College Boulevard, Santa Clara, CA, USA",
            "notes": "",
            "geoLatitude": 37.3905822,
            "geoLongitude": -121.9742264,
            "shortAddress": "Santa Clara, CA"
        },
        "user": "test@test.com",
        "phaseNumber": 1,
        "courier": "dhl",
        "members": [
            "test@test.com"
        ],
        "phoneNumber": "6509901234",
        "created": "2023-03-15T04:40:01.814000",
        "modified": "2023-04-03T00:20:07.325000",
        "totalWeight": 1.7,
        "id": "64114c2104c6777b3e65ca94"
    },
    {
        "name": "Snack Lovers",
        "shipRoute": "Air Sensitive",
        "shipEndDate": "2023-05-12T19:00:00",
        "pickupLocation": {
            "name": "Jasmine Lee",
            "address": "5093 Disk Drive, San Jose, CA, USA",
            "notes": "",
            "geoLatitude": 37.4275749,
            "geoLongitude": -121.9663161,
            "shortAddress": "San Jose, CA"
        },
        "user": "test@test.com",
        "phaseNumber": 0,
        "courier": "dhl",
        "members": [],
        "created": "2023-03-15T04:41:15.316000",
        "modified": "2023-03-15T04:41:15.316000",
        "totalWeight": 0.0,
        "id": "64114c6bbd7c774187a11f07"
    },
    {
        "name": "Cupertino Shoppers",
        "shipRoute": "Sea Standard",
        "shipEndDate": "2023-05-24T19:00:00",
        "pickupLocation": {
            "name": "Thomas Wang",
            "address": "85°C Bakery Cafe - Cupertino, Stevens Creek Boulevard, Cupertino, CA, USA",
            "notes": "",
            "geoLatitude": 37.32390399999999,
            "geoLongitude": -122.011104,
            "shortAddress": "Cupertino, CA"
        },
        "user": "test@test.com",
        "phaseNumber": 4,
        "courier": "dhl",
        "members": [
            "test@test.com"
        ],
        "phoneNumber": "5509908987",
        "created": "2023-03-16T04:34:34.650000",
        "modified": "2023-03-16T04:34:34.650000",
        "totalWeight": 3.9,
        "id": "64129c5a2d97dfd382bc4d57"
    },
    {
        "name": "Toy Lovers",
        "shipRoute": "Air Standard",
        "shipEndDate": "2023-04-26T19:00:00",
        "pickupLocation": {
            "name": "test@test.com",
            "address": "389 East Arques Avenue, Sunnyvale, CA, USA",
            "notes": "",
            "geoLatitude": 37.3828992,
            "geoLongitude": -122.0230271,
            "shortAddress": "Sunnyvale, CA"
        },
        "user": "test@test.com",
        "phaseNumber": 0,
        "courier": "dhl",
        "members": [],
        "created": "2023-03-30T01:51:47.014000",
        "modified": "2023-03-30T01:51:47.014000",
        "totalWeight": 0.0,
        "id": "6424eb33d0563c9059222bcc"
    },
    {
        "name": "Wonderful Ship",
        "shipRoute": "Air Standard",
        "shipEndDate": "2023-04-29T19:00:00",
        "pickupLocation": {
            "name": "test@test.com",
            "address": "453 Ravendale Drive, Sunnyvale, CA, USA",
            "notes": "",
            "geoLatitude": 37.390518,
            "geoLongitude": -122.0511617,
            "shortAddress": "Sunnyvale, CA"
        },
        "user": "test@test.com",
        "phaseNumber": 0,
        "courier": "dhl",
        "members": [],
        "created": "2023-03-31T04:06:42.475000",
        "modified": "2023-03-31T04:06:42.475000",
        "totalWeight": 0.0,
        "id": "64265c52d15c593394908b55"
    },
    {
        "name": "Sunnyvale Sea Group",
        "shipRoute": "Sea Sensitive",
        "shipEndDate": "2023-04-30T19:00:00",
        "pickupLocation": {
            "name": "test@test.com",
            "address": "909 Kifer Road, Sunnyvale, CA, USA",
            "notes": "",
            "geoLatitude": 37.3752998,
            "geoLongitude": -122.0092395,
            "shortAddress": "Sunnyvale, CA"
        },
        "user": "test@test.com",
        "phaseNumber": 0,
        "courier": "dhl",
        "members": [],
        "created": "2023-04-03T06:00:03.757000",
        "modified": "2023-04-03T06:00:03.757000",
        "totalWeight": 0.0,
        "id": "642a6b63d9cee35dbdc12d90"
    }
]